import 'lib/jquery.fitvids.js'
jQuery(() => {
	jQuery('main').fitVids({
		customSelector: 'iframe[data-src*="youtube.com"], iframe[data-src*="youtube-nocookie.com"]',
		ignore: '.wp-block-file__embed', // ignore File block embeds
	});
});